const projects = [
  {
    id: 1,
    title: 'Amharic AI',
    description: 'ChatGPT in Amharic for Ethiopian audience',
    link: 'https://icramdoku.github.io/Amharic-Translator-AI/',
    image: 'AmharicAI.png'
  },
  {
    id: 2,
    title: 'Task Meister',
    description: 'A collaborative tasks web app with Due dates',
    link: 'https://icramdoku.github.io/cmsc447project/',
    image: 'TaskMeister.png'
  },
  {
    id: 3,
    title: 'Course Registration',
    description: 'A student registration simulator web app',
    link: 'https://icramdoku.github.io/cmsc-447/#/cmsc-447/',
    image: 'CourseRegistration.png'
  },
  {
    id: 4,
    title: 'SimplyCS',
    description: 'A mobile quiz app in computer science topics',
    link: 'https://play.google.com/store/apps/details?id=com.icramdoku.simplycs',
    image: 'SimplyCS.png'
  },
  {
    id: 5,
    title: 'Weight Tracker',
    description: 'A daily weight logging web app',
    link: 'https://icram.pythonanywhere.com/',
    image: 'WeightTracker.png'
  },
  {
    id: 6,
    title: 'Simple Budget',
    description: 'A budget calculator and first web app I hosted',
    link: 'https://icramdoku.github.io/SimplyBudget.github.io/',
    image: 'SimpleBudget.png'   
  }

];

const skills = [
  { name: 'Python', icon: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg' },
  { name: 'C++', icon: 'https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg' },
  { name: 'JavaScript', icon: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png' },
  { name: 'Java', icon: 'https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/181_Java_logo_logos-512.png' },
  { name: 'Dart', icon: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Dart-logo.png' },
  { name: 'Typescript', icon: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg' },
  { name: 'CSS', icon: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg' },
  { name: 'HTML', icon: 'https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg' },
  { name: 'Tailwind', icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeKPw4CK4jcH7udsFHZdiB3iIOuI3fUCsxUZosXy4Y1yd25NA-dzCBPrSDIhg1BwObl3w&usqp=CAU' },
  { name: 'React', icon: 'https://cdn.worldvectorlogo.com/logos/react-1.svg' },
  { name: 'Node', icon: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg' },
  { name: 'Flutter', icon: 'https://static-00.iconduck.com/assets.00/flutter-icon-1651x2048-ojswpayr.png' },
  { name: 'MongoDB', icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTNyOe4xJhJFvDUbm1OSFnnEc4plFTvdYrBmOfNf-YUNA&s' },
  { name: 'MySQL', icon: 'https://dh.library.virginia.edu/system/files/styles/large/private/MySQL.PNG?itok=y4tI90y8' },
  { name: 'CI/CD', icon: 'https://media.licdn.com/dms/image/D4D12AQEtvcUNf2bUKw/article-cover_image-shrink_600_2000/0/1655882257308?e=2147483647&v=beta&t=cWAmA9sFyS7IFrHJzFrDxigqFzM2MYLLs2XL0dNDL9U' },
  { name: 'ML', icon: 'https://img.freepik.com/premium-vector/machine-learning-signs-round-design-template-thin-line-icon-concept-banner-ad-blue-vector-illustration_269504-3518.jpg'},
  { name: 'AI', icon: 'https://t4.ftcdn.net/jpg/03/97/02/07/360_F_397020794_LXE0WLqWxcbhIf2UwXfRtLJwjw8aX5Wj.jpg'},
  { name: '...', icon: 'https://cdn-icons-png.flaticon.com/512/152/152529.png'}
];


const contactDetails = {
  email: 'icramdoku@gmail.com',
  linkedin: 'https://www.linkedin.com/in/icramdoku'
};

const githubLink = 'https://github.com/IcramDoku';

const devpostLink = 'https://devpost.com/IcramDoku?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav';

export { projects, skills, contactDetails, githubLink, devpostLink };
  